module.exports = __webpack_public_path__ + "static/media/keep_with_hen.09c83d60.png";